/* eslint-disable @typescript-eslint/naming-convention */
import { TreePlanInfo, TreeUsage } from './plan.model';

export class User {
    email?: string;
    password?: string;
    legal_name?: string;
    legal_surname?: string;
    username?: string;
    language?: string;
    /** Zgody z formularza rejestracji - backend zapisuje moment akceptacji. */
    terms_accepted?: boolean;
    privacy_accepted?: boolean;
    /** Administrator całego serwisu (panel /admin); flaga nadawana w bazie. */
    is_site_admin?: boolean;
    /** Okno „Dodaj osobę” pyta AI o płeć wpisanego imienia (migracja 094). */
    ai_name_sex?: boolean;
}

export class UserPasswordChange {
    oldPassword?: string;
    newPassword?: string;
    repeatPassword?: string;
}

/** Podsumowanie skutków usunięcia konta */
export class AccountDeletionTree {
    id!: number;
    title!: string;
    url!: string;
    /**
     * Kod OPŁACONEGO planu drzewa; brak pola = drzewo nic nie kosztowało
     * (plan darmowy albo darmowy miesiąc Ultra, za który nikt nie zapłacił).
     */
    paid_plan?: string;
    /** Koniec opłaconego okresu - po usunięciu konta przepada bez zwrotu */
    paid_until?: string;
}

export class AccountDeletionInfo {
    username?: string;
    /** Drzewa, w których jesteś jedynym członkiem - znikną razem z kontem */
    treesToDelete?: AccountDeletionTree[];
    /** Drzewa, w których jesteś jedynym super administratorem, a są inni członkowie */
    treesBlocking?: AccountDeletionTree[];
    /** Drzewa, z których po prostu wypiszemy Cię z listy użytkowników */
    treesToLeave?: AccountDeletionTree[];
}

export class UserTree {
    tree_id!: number;
    membershiplevel?: number;
    def?: boolean;
    title?: string;
    url?: string;
    owner?: string;
    /** Plan efektywny drzewa (migracja 059) */
    plan?: TreePlanInfo;
    /** Zużycie drzewa - osoby i bajty plików */
    usage?: TreeUsage;
}
